import { useEffect } from "react";
import { useAccessStore } from "../store/accessStore";
import { useUserStore } from "../store/userStore";

export function useAccessBootstrap(): void {
  const storedUserId = useUserStore((state) => state.user?.id ?? null);
  const load = useAccessStore((state) => state.load);
  const clear = useAccessStore((state) => state.clear);

  useEffect(() => {
    const userId = storedUserId ?? localStorage.getItem("userId");
    const token = localStorage.getItem("token");

    if (!userId || !token) {
      clear();
      return;
    }

    load(userId);
  }, [storedUserId, load, clear]);
}

export default useAccessBootstrap;
